import { Icon } from '@busybusy/webapp-react-ui';
import { LockOutlineIcon } from 'assets/icons';
import UpgradePromptView, { FreemiumViewType } from 'containers/settings/subscriptions/UpgradePromptView/UpgradePromptView';
import { t } from 'i18next';
import { ClassName } from 'types/ClassName';

export type LimitReachedType = 'project' | 'costCode' | 'equipment';

export interface ILimitReachedViewProps {
  className?: ClassName;
  limitType: LimitReachedType;
  isOpen: boolean;
  onClose: () => void;
}

const LIMIT_COPY: Record<LimitReachedType, { singular: string; plural: string; viewType: FreemiumViewType }> = {
  project: { singular: 'Project', plural: 'projects', viewType: 'projects_limited' },
  costCode: { singular: 'Cost Code', plural: 'cost codes', viewType: 'cost_codes_limited' },
  equipment: { singular: 'Equipment', plural: 'equipment', viewType: 'equipment_limited' },
};

const LimitReachedView = (props: ILimitReachedViewProps) => {
  const { className, limitType, isOpen, onClose } = props;
  const copy = LIMIT_COPY[limitType];

  return (
    <UpgradePromptView
      className={className}
      icon={<Icon svg={LockOutlineIcon} size={64} />}
      title={t('{{item}} Limit Reached', { item: t(copy.singular) })}
      description={
        limitType === 'project'
          ? t(
              'Your current plan no longer supports creating more than 5 active projects*. If you need more flexibility, please consider upgrading your plan.'
            )
          : t(
              'Your current plan no longer supports creating more than 5 active {{items}}. If you need more flexibility, please consider upgrading your plan.',
              { items: t(copy.plural) }
            )
      }
      offerDescription={t(
        "We'd like to offer you two exclusive, reduced-price plan options not available to all customers."
      )}
      footer={limitType === 'project' ? t('*Active project total includes subprojects') : undefined}
      viewType={copy.viewType}
      isOpen={isOpen}
      onClose={onClose}
    />
  );
};

export default LimitReachedView;
